import React, { useEffect, useState, useContext } from 'react';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Prescription from '../../components/Medication/Prescription';
import Add from '@material-ui/icons/Add';
import { getAllPrescriptions } from '../../redux/Drug/DrugAction';
import { useParams } from 'react-router-dom';
import MessagesContext from '../../contexts/messagesContext';
import WithPatientFileHeader from '../../components/PatientFileHeader/WithPatientFileHeader';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Drug/DrugType';
import useCheckAccess from '../../hooks/useCheckAccess';
const styles = makeStyles((theme) => ({
    header: {
        margin: ' 0 0 50px 0',
        [theme.breakpoints.down('1025')]: {
            margin: '0 24px 24px 0'
        }
    },
    listContainer: {},
    addBtn: {
        borderRadius: '4px',
        // boxShadow: '0 3px 6px 0 rgba(10, 23, 85, 0.4)',
        width: '100%',
        border: '1.5px dashed #509ffa',
        background: 'transparent',
        color: '#509ffa',
        boxShadow: 'none',
        '&:disabled': {
            background: 'transparent',
            color: '#509ffa',
            opacity: '0.5',
            cursor: 'not-allowed',
            pointerEvents: 'all !important'
        },
        '&[disabled]:hover': {
            background: 'transparent'
        }
    },
    addIcon: {
        width: '32px',
        height: '32px'
    },
    innerContainer: {
        // height: '100%',
        position: 'relative'
        // [theme.breakpoints.down('md')]: {
        //     background: '#f5f6fa'
        // }
    }
}));
function Drug() {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const prescriptions = useSelector((state) => state.drug?.prescriptions);
    const loadingSelector = createLoadingSelector(type.SET_PRESCRIPTIONS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const [addNew, setAddNew] = useState(false);
    const params = useParams();
    const dispatch = useDispatch();
    const { notEditClinical } = useCheckAccess();
    useEffect(() => {
        const patientId = params.id;
        dispatch(getAllPrescriptions(patientId));
    }, [params.id]);
    useEffect(() => {
        setAddNew(false);
    }, [prescriptions]);
    const handleReload = () => {};
    const handleCancelAddNew = () => {
        setAddNew(false);
    };
    return (
        <>
            <div className={classes.innerContainer}>
                <div className={classes.header}>
                    <Button
                        variant="contained"
                        className={classes.addBtn}
                        onClick={() => setAddNew(true)}
                        data-testid="addPrescription"
                        disabled={notEditClinical}
                    >
                        <Add className={classes.addIcon} />
                        {messages.newPrescription}
                    </Button>
                </div>
                {isLoading && (
                    <div className="loadingContainer">
                        <CircularProgress />
                    </div>
                )}
                <div className={classes.listContainer}>
                    {addNew && !notEditClinical && (
                        <Prescription
                            prescription={null}
                            patientId={params?.id}
                            addNew={true}
                            handleCancel={() => handleCancelAddNew()}
                            handleRefresh={handleReload}
                        />
                    )}
                    {prescriptions?.map((item) => (
                        <Prescription
                            prescription={item}
                            key={item.id}
                            handleRefresh={handleReload}
                            notEditClinical={notEditClinical}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}
export default WithPatientFileHeader(Drug, ['sidebar', 'medication']);
